/* eslint-disable max-len */
/* eslint-disable no-useless-escape */
import React, { Component } from "react";
import fetchHandler from "@/fetch/fetchHandler";
import { ExportOutlined, UploadOutlined } from "@ant-design/icons";
import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import { message, Input, Button, Upload, Table } from "antd";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import { updateTask, prefixFile, getStubCfgTableInfo } from "../../../fetch/fetchApi";
import { TableLocale } from "../../../utils/publicParam";

class CfgChangeTaskBuildClass extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.cfgChangeTaskBuild;
    this.state = {
      resultArray: [],
      tableConfig: {},
      headerTemp: [],
      zhHeader: [],
      bodyTemp: [],
      resultArrayTemp: [],
      data: [],
      tableColumns: [],
      fileName: "",
      buttonDescrible: this.props.intl.messages.cfgChangeTaskBuild.btn1, // "配置上传",
      errCount: 0,
      display: "none",
      taskName: "",
      taskId: "",
      btnDisplay: "",
    };
    this.init();
  }

  init() {
    if (this.props.isView) {
      // 查看頁面
      console.log(this.props.taskInfo);
      this.state.taskName = this.props.taskInfo.operationName;
      this.state.display = "";
      this.state.btnDisplay = "none";
      this.state.taskId = this.props.taskInfo.key;
    } else {
      // 创建页面
      this.state.taskName = this.props.taskName;
      this.state.taskId = this.props.taskId;
    }
    // 调用接口获取数据
    this.fetch();
    // 数据填充表格
    this.addTable();
  }

  fetch() {
    console.log("fecth 方法执行");
    // 表格加载效果
    this.setState({
      tableLoading: true,
    });
    fetchHandler(getStubCfgTableInfo, {
      taskName: this.state.taskName,
      taskId: this.state.taskId,
    }).then((res) => {
      if (res && res.code === "success") {
        const result = res.data;
        this.state.errCount = result.errorCount;
        this.state.zhHeader = [];
        this.state.resultArrayTemp = [];
        this.state.bodyTemp = [];
        for (let i = 0; i < result.cfgData.length; i++) {
          const resultArray1 = {};
          Object.keys(result.cfgData[i]).forEach((key) => {
            resultArray1[key] = result.cfgData[i][key];
          });
          this.state.resultArrayTemp.push(resultArray1);
        }
        // 头部信息
        const enHeader = result.enHeader;
        this.state.zhHeader = result.zhHeader;
        for (let i = 0; i < this.state.zhHeader.length; i++) {
          if (i === 0) {
            this.state.bodyTemp.push({
              title: this.state.zhHeader[i],
              dataIndex: enHeader[i],
              align: "center",
              colType: "textCol",
              fixed: true,
              width: 50,
              render: (text) => {
                if (text.match("errMsg")) {
                  return (
                    <div style={text.match("errMsg") ? { color: "red" } : {}}>
                      {text.split("-")[0].replace(/\"/g, "")}
                    </div>
                  );
                } else {
                  return <div>{text}</div>;
                }
              },
            });
          } else {
            this.state.bodyTemp.push({
              title: this.state.zhHeader[i],
              dataIndex: enHeader[i],
              align: "center",
              colType: "textCol",
              render: (text) => {
                if (text.match("errMsg")) {
                  return (
                    <div style={text.match("errMsg") ? { color: "red" } : {}}>
                      {text.split("-")[0].replace(/\"/g, "")}
                    </div>
                  );
                } else {
                  return <div>{text}</div>;
                }
              },
            });
          }
        }
        this.setState({
          bodyTemp: this.state.bodyTemp,
        });
      }
    });
  }

  addTable() {
    this.setState({
      tableColumns: this.state.bodyTemp,
    });
  }

  handleExportBtnClick = () => {
    const excelUrl = `${prefixFile}/exportUploadStubCfg.do`;
    const params = `taskName=${this.state.taskName}&&taskId=${this.state.taskId}`;
    const ele = document.createElement("a");
    ele.download = encodeURI(`${excelUrl}?${params}`);
    ele.style.display = "none";
    ele.href = encodeURI(`${excelUrl}?${params}`);
    ele.target = "_blank"; // 针对 ie模式 的浏览器
    // 触发点击
    document.body.appendChild(ele);
    ele.click();
    // 然后移除
    document.body.removeChild(ele);
  };

  handleUpdateTaskBtnClick = () => {
    if (this.state.bodyTemp.length === 0) {
      message.warning("配置内容不能为空！");
    } else {
      // 往数据库任务表更新一条数据 增加备注信息
      fetchHandler(updateTask, {
        taskName: this.state.taskName,
        taskId: this.state.taskId,
        comments: this.state.comments,
      }).then((res) => {
        // 保存成功 关闭窗口
        if (res && res.code === "success") {
          message.success(this.internationalization.msg2);
          if (this.props.onCancel) {
            this.props.onCancel();
          }
          if (this.props.refreshGrid) {
            this.props.refreshGrid();
          }
        }
      });
    }
  };

  handleCacelBtnClick = () => {
    // 取消 删除桩配置信息表中与任务关联的桩配置信息
    // fetchHandler(deleteStubCfg, {
    //     taskName: this.state.taskName
    // }).then((res) => {
    //     //保存成功 关闭窗口
    //     if(res && res.code === "success"){
    //         this.props.onCancel && this.props.onCancel();
    //     }
    // });
    if (this.props.onCancel) {
      this.props.onCancel();
    }
  };

  inputChange(e) {
    this.setState({
      comments: e.target.value,
    });
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  render() {
    // const {getFieldDecorator} = this.props.form;
    const uploadProps = {
      name: "file",
      multiple: false,
      accept: ".xls",
      action: `${prefixFile}/oss/importStubCfg.do?taskName=${this.state.taskName}&taskId=${this.state.taskId} `,
      headers: {
        authorization: "authorization-text",
      },
      showUploadList: false,
      onChange: (info) => {
        if (info.file.response !== undefined) {
          this.state.display = "";
          message.success(info.file.name + this.internationalization.msg3);
          this.state.fileName = info.file.name;
          this.state.buttonDescrible = this.internationalization.msg4;
          this.init();
        }
      },
    };

    return (
      <Form className='login-form'>
        <Form.Item
          label={`${this.internationalization.title1}:`}
          labelCol={{ span: 5 }}
          wrapperCol={{ span: 15 }}
          style={{
            marginBottom: "1px",
          }}>
          {this.state.taskName}
        </Form.Item>

        <Form.Item
          label={`${this.internationalization.title2}:`}
          labelCol={{ span: 5 }}
          wrapperCol={{ span: 15 }}
          style={{ display: this.state.btnDisplay }}>
          <span>{this.state.fileName}</span>&nbsp;&nbsp;&nbsp;
          <Upload {...uploadProps}>
            <Button type='primary' loading={this.state.btnLoading} style={{ display: this.state.btnDisplay }}>
              <UploadOutlined />
              {this.state.buttonDescrible}
            </Button>
          </Upload>
        </Form.Item>

        <Form.Item label={`${this.internationalization.title3}:`} labelCol={{ span: 5 }} wrapperCol={{ span: 15 }}>
          <Table
            columns={this.state.bodyTemp}
            dataSource={this.state.resultArrayTemp}
            bordered
            locale={TableLocale}
            className="sc-table"
            footer={this.state.resultArrayTemp && this.state.resultArrayTemp.length ? () => <div></div> : null}
            scroll={{ x: "50%" }}
          />
        </Form.Item>

        <Form.Item label={`${this.internationalization.title4}:`} labelCol={{ span: 5 }} wrapperCol={{ span: 15 }}>
          {this.state.errCount === 0 ? (
            <span style={{ color: "green", display: this.state.display }}>{this.internationalization.title5}</span>
          ) : (
            <span style={{ color: "red" }}>
              {this.state.errCount}
              {this.internationalization.title6}
            </span>
          )}
          &nbsp;&nbsp;&nbsp;
          <Button type='primary' onClick={this.handleExportBtnClick} icon={<ExportOutlined />}>
            {this.internationalization.btn5}
          </Button>
        </Form.Item>

        <Form.Item label='备注:' labelCol={{ span: 5 }} wrapperCol={{ span: 15 }}>
          {this.props.isView === true ? (
            <Input.TextArea value={this.props.taskInfo.comments} />
          ) : (
            <Input.TextArea onChange={(e) => this.inputChange(e)} />
          )}
        </Form.Item>

        <Form.Item wrapperCol={{ span: 15, offset: 5 }}>
          <Button type='primary' onClick={this.handleUpdateTaskBtnClick} style={{ display: this.state.btnDisplay }}>
            {this.internationalization.btn3}
          </Button>
          <Button
            type='default'
            onClick={this.handleCacelBtnClick}
            style={{ display: this.state.btnDisplay, marginLeft: "20px" }}>
            {this.internationalization.btn4}
          </Button>
        </Form.Item>
        <Form.Item>
          <Button type='primary'>上传并校验</Button>
        </Form.Item>
      </Form>
    );
  }
}

const CfgChangeTaskBuild = Form.create()(CfgChangeTaskBuildClass);

export default injectIntl(CfgChangeTaskBuild);



// WEBPACK FOOTER //
// ./src/AntD/pages/onlineOperations/taskManagement/cfgChangeTaskBuild.js